import * as React from "react";
const SvgVariant10 = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m8.845 13.72 1.06 1.06L15.685 9l-5.78-5.78-1.06 1.06 3.97 3.97H2.25v1.5h10.564z" }));
export default SvgVariant10;
